export const ContractPillSkeleton = () => {
  return <div className="mt-1 h-3 w-32 animate-pulse rounded-lg bg-slate-200" />;
};
